import React from 'react';
import SarasWrapper from "../../container/SarasWrapper";
import SarasCheckBox2 from '../../input/checkbox/SarasCheckBox2';
import SarasTrans from '../../notifications/SarasTrans';
import * as fn from "../../../helper/uiFunctions";

const SarasRowSelector = (props) => {
    const { rowSelector, rowID, customWrapper, wrapperStyle, wrapperClass, className, useCheckBox } = props;

    const isRowSelected = rowSelector && rowSelector.isRowSelected(rowID);
    
    //track the available rows of the current page
    if(rowSelector) rowSelector.onTrackAvailableRows(rowID);

    const onBtnClick = () => {
        rowSelector.onRowSelectClick(rowID)
    }

    const renderRow = () => {
        if (useCheckBox) {
            return (
                <SarasCheckBox2 value={isRowSelected ? "1" : "0"} onClick={onBtnClick} />
            )
        }
        else {
            return (
                <span className={`${className} ${isRowSelected ? 'uiSelected' : ''}`} onClick={onBtnClick} >
                    <SarasTrans value={isRowSelected ? "Remove" : "Add"}/>
                </span>
            )
        }
    }

    if(rowSelector && (fn.compareNumber(rowSelector.isEnableSelect(), 1) || 
                       fn.compareNumber(rowSelector.isEnableSelect(), 2))){
        return (
            <SarasWrapper customWrapper={customWrapper} wrapperStyle={wrapperStyle} wrapperClass={wrapperClass} >
                {renderRow()}
            </SarasWrapper>
        )
    }

    return null;
}

export default SarasRowSelector